import React, { PureComponent } from 'react';
import styled from 'styled-components';

const StartText = styled.p`
  width: 100%;
  text-: 20px;
  font-size: 20px;
  font-weight: bold;
  color: #000;
  line-height: 1.2;
  text-transform: none;
`;

const Radio = styled.input``;

const RadioGroup = styled.div`
  display: grid;
  margin-top: ${props => props.top};
`;
const Span = styled.span`
  display: inline-block;
  position: relative;
  margin-top: 1px;
  background-color: #fff;
  border: 1px solid #000;
  border-radius: 50%;
  cursor: pointer;
  height: 10px;
  left: 0;
  position: absolute;
  top: 0;
  width: 10px;

  :after {
    border: 2px solid #fff;
    border-top: none;
    border-right: none;
    content: '';
    height: 2px;
    left: 1.5px;
    opacity: 0;
    position: absolute;
    top: 2.5px;
    transform: rotate(-45deg);
    width: 5px;
  }
`;

const Label = styled.label`
  display: inline-block;
  cursor: pointer;
  position: relative;
  font-family: HelveticaNeueLTPro-Roman;
  color: #000;
  padding-left: 30px;
  padding-bottom: 5px;
`;

const Input = styled.input`
  display: none;

  :checked + label > span {
    background-color: #5bb9ef;
    border-color: #5bb9ef;
  }

  :checked + label > span:after {
    opacity: 1;
  }
`;

const Round = styled.div`
  text-transform: none;
`;

export default class AddionalFeatures extends PureComponent {
  setConfiguration(attr, val) {
    const { setCurrentSelection } = this.props;
    setCurrentSelection(attr, val);
  }

  render() {
    const { addtionalAttributes, currentSelection } = this.props;
    if (!addtionalAttributes) return null;
    return (
      <div>
        {Object.keys(addtionalAttributes).map(key => {
          const attribute = addtionalAttributes[key];
          const currentVal = currentSelection[attribute.name];
          return (
            <RadioGroup key={key} top="20px">
              {attribute.values.map(val => (
                <Round key={val}>
                  <Input
                    type="checkbox"
                    id={val}
                    checked={val === currentVal}
                  />
                  <Label
                    onClick={e => this.setConfiguration(attribute.name, val)}
                  >
                    <Span />
                    {val}
                  </Label>
                </Round>
              ))}
            </RadioGroup>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accords/AddionalFeatures.js